import { AdSlot, useAdConfig } from "../contexts/ad-config-context.tsx";

export const useGoogleAds = () => {
  const adConfig = useAdConfig();
  const getSlot = (name: string): AdSlot | undefined => adConfig?.adSlots?.find((s) => s.adSlotName === name);
  return { getSlot, networkCode: adConfig?.networkCode };
};
